<template>
  <div>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->
    <b-row>
      <b-col cols="12">
        <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
          <template v-slot:header>
            <b-row class="text-left">
              <b-col cols="3">
                <span>
                  <b style="font-weight:bolder;color:#3b3e66">Training & Exams</b>
                </span>
              </b-col>
              <b-col cols="4">
                <b-button variant="outline-info" size="sm" class="mr-2" @click="reloadTable">
                  <!-- <font-awesome-icon icon="sync" /> -->
                  Reload
                </b-button>
              </b-col>
              <b-col cols="5">
                <b-form-group>
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>

          <b-table
            striped
            sticky-header="calc(100vh - 280px)"
            ref="table"
            id="users-data-table"
            :busy.sync="isLoading"
            :fields="staticFields"
            :items="getOnboardingTableData"
            :filter="filter"
            hover
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            no-sort-reset
          >
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="field.width ? 'width:'+field.width : ''"
              />
            </template>

            <template v-slot:cell(employee_name)="data">
              <div>
                <b-avatar></b-avatar>
                &nbsp;{{data.item.first_name+' '+data.item.last_name}}
                <br />
                {{'(department)'}}
              </div>
            </template>
            <template v-slot:cell(abc_training)="data">
              <div class="text-left">
                <span style>Status:</span>
                <span class="text-muted">
                  <b-badge variant="danger">OVERDUE</b-badge>
                </span>
                <br />
                <span>Last Viewed:</span>
                <span class="text-muted">3 days Ago</span>
                <br />
                <span>Numbers of reminders sent:</span>
                <span class="text-muted">3</span>
                <br />
                <span>Latest reminder:</span>
                <span class="text-muted">12 days ago</span>
                <br />
                <span>Last completed:</span>
                <span class="text-muted">Next Renewal:</span>
                <br />
                <span>Next Renewal:</span>
                <span class="text-muted">Next Renewal:</span>
              </div>
            </template>
            <template v-slot:cell(abc_exams)="data">
              <div class="text-left">
                <span style>Status:</span>
                <span class="text-muted">
                  <b-badge variant="danger">OVERDUE</b-badge>
                </span>
                <br />
                <span style>Attempts:</span>
                <span class="text-muted">
                  <b-badge variant="dark">0</b-badge>
                </span>
                <br />
                <span style>Last completed:</span>
                <span class="text-muted">N/A</span>
                <br />
                <span style>Next Renewal:</span>
                <span class="text-muted">N/A</span>
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-navbar type="light" variant="white" fixed="bottom" class="shadow-sm">
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-navbar-nav>
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-navbar-nav>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <span class="text-center">
              Displaying results From
              <b>{{fromRows}}</b> to
              <b>{{toRows}}</b>
            </span>
          </b-navbar-nav>
        </b-collapse>
        <b-collapse id="nav-collapse" is-nav style="margin-left: 20rem;">
          <b-navbar-nav>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="my-table"
            ></b-pagination>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </b-row>

    <b-overlay :show="isLoading" rounded="sm"></b-overlay>
    <b-modal
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Assign User"
      v-model="showAssignModal"
      size="md"
    >
      <b-form-group>
        <label class="text-left">Select User</label>
        <v-select
          @input="setSelectedUserValue"
          label="user_full_name"
          v-model="selectedUser"
          :options="usersOptions"
        ></v-select>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button @click="closeAssignModal" variant="outline-danger">Close</b-button>
        <b-button @click="assignUser" variant="outline-success">Assign</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "OnboardingPage",
  data() {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Onboarding",
          href: "#",
          active: true,
        },
      ],
      showAssignModal: false,
      isLoading: false,
      totalRows: 0,
      fromRows: 0,
      toRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        {
          key: "employee_name",
          label: "Employee",
          sortable: true,
        },

        {
          key: "abc_training",
          label: "ABC Training",
          sortable: false,
        },
        {
          key: "abc_exams",
          label: "ABC EXAM",
          sortable: false,
        },

        {
          key: "actions",
          label: "",
          sortable: false,
        },
      ],
      taskTableFields: [],
      usersOptions: [],
      selectedUser: null,
      selectedUserValue: null,
      onboardingId: null,
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {
    this.getUsersList();
  },
  methods: {
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    getAssignedUserName(data) {
      let firstName = data.item.owner_contact_first_name.toUpperCase();
      let lastName = data.item.owner_contact_last_name.toUpperCase();
      let name = firstName.charAt(0) + lastName.charAt(0);

      return name;
    },
    async getUsersList() {
      this.usersOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP("get", "api/v1/user/list", null);
        this.usersOptions = result.data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    openAssignUserModal(data) {
      this.onboardingId = data.item.id;
      this.showAssignModal = true;
    },
    setSelectedUserValue(value) {
      this.selectedUserValue = null;
      this.selectedUserValue = value.id;
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "users-data-table");
    },
    async getOnboardingTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        const response = await HTTP(
          "post",
          "api/v1/onboarding/data",
          formData,
          {
            Authorization: token,
          }
        );
        this.isLoading = false;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.totalRows = response.data.total;
        return response.data.data;
        // return items;
      } catch (err) {
        this.isLoading = false;
        return [err];
      }
    },
    closeAssignModal() {
      this.showAssignModal = false;
      this.selectedUserValue = null;
      this.selectedUser = null;
    },
    async assignUser() {
      let formData = {
        owner_id: this.selectedUserValue,
        user_id: localStorage.getItem("userId"),
      };
      try {
        await HTTP(
          "post",
          "api/v1/onboarding/assign/owner/" + this.onboardingId,
          formData
        );
        this.reloadTable();
        this.closeAssignModal();
      } catch (err) {
        return [err];
      }
    },
  },
};
</script>

<style scoped>
@import "../../../assets/styles/theme1/tabs.css";
@import "../../../assets/styles/theme1/timeline.css";

.card-body {
  padding: 0px;
}

.fixed-bottom {
  right: auto !important;
  left: auto !important;
  width: 100%;
}
</style>

<style>
body {
  font-family: Heebo, sans-serif;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.5;
  color: #3b3e66;
}
.card-header {
  /* #background-color:#dcdef1; */
  /* padding: 0.4rem 0.4rem; */

  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 0 solid rgba(122, 123, 151, 0.3);
}
/* .table .thead-light th {
    color: #3b3e66;
    background-color: rgba(239,239,247,.7);
    border-color: #dcdef1;
} */
.table {
  font-size: 0.83125rem;
  color: #3b3e66;
}
.table.b-table > thead > tr .table-b-table-default {
  background-color: rgba(239, 239, 247, 0.7);
  color: #3b3e66;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f9fafe;
  color: #3b3e66;
}
.table thead th {
  text-transform: uppercase;

  font-size: 0.83125rem;

  border-color: #dcdef1;
  vertical-align: bottom;
  border-bottom: 2px solid #dcdef1;
}

.form-group {
  margin-bottom: 0rem;
}

.group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  font-size: 0.75rem;
}
.progress {
  height: 0.5rem;
}

.btn-sm {
  font-size: 0.75rem;
}
</style>
